export default __webpack_public_path__ + "static/media/SaveIconHover.b596b581.svg";